import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { RenderTexture } from './RenderTexture.mjs';
import { BaseRenderTexture } from './BaseRenderTexture.mjs';
import { nextPow2 } from '@pixi/utils';
import { MSAA_QUALITY } from '@pixi/constants';
var RenderTexturePool = /*#__PURE__*/function () {
  function RenderTexturePool(textureOptions) {
    _classCallCheck(this, RenderTexturePool);
    this.texturePool = {};
    this.textureOptions = textureOptions || {};
    this.enableFullScreen = false;
    this._pixelsWidth = 0;
    this._pixelsHeight = 0;
  }
  _createClass(RenderTexturePool, [{
    key: "createTexture",
    value: function createTexture(realWidth, realHeight) {
      var multisample = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MSAA_QUALITY.NONE;
      var baseRenderTexture = new BaseRenderTexture(Object.assign({
        width: realWidth,
        height: realHeight,
        resolution: 1,
        multisample: multisample
      }, this.textureOptions));
      return new RenderTexture(baseRenderTexture);
    }
  }, {
    key: "getOptimalTexture",
    value: function getOptimalTexture(minWidth, minHeight) {
      var resolution = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var multisample = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : MSAA_QUALITY.NONE;
      var key;
      minWidth = Math.ceil(minWidth * resolution - 1e-6);
      minHeight = Math.ceil(minHeight * resolution - 1e-6);
      if (!this.enableFullScreen || minWidth !== this._pixelsWidth || minHeight !== this._pixelsHeight) {
        minWidth = nextPow2(minWidth);
        minHeight = nextPow2(minHeight);
        key = ((minWidth & 65535) << 16 | minHeight & 65535) >>> 0;
        if (multisample > 1) {
          key += multisample * 4294967296;
        }
      } else {
        key = multisample > 1 ? -multisample : -1;
      }
      if (!this.texturePool[key]) {
        this.texturePool[key] = [];
      }
      var renderTexture = this.texturePool[key].pop();
      if (!renderTexture) {
        renderTexture = this.createTexture(minWidth, minHeight, multisample);
      }
      renderTexture.filterPoolKey = key;
      renderTexture.setResolution(resolution);
      return renderTexture;
    }
  }, {
    key: "getFilterTexture",
    value: function getFilterTexture(input, resolution, multisample) {
      var filterTexture = this.getOptimalTexture(input.width, input.height, resolution || input.resolution, multisample || MSAA_QUALITY.NONE);
      filterTexture.filterFrame = input.filterFrame;
      return filterTexture;
    }
  }, {
    key: "returnTexture",
    value: function returnTexture(renderTexture) {
      var key = renderTexture.filterPoolKey;
      renderTexture.filterFrame = null;
      this.texturePool[key].push(renderTexture);
    }
  }, {
    key: "returnFilterTexture",
    value: function returnFilterTexture(renderTexture) {
      this.returnTexture(renderTexture);
    }
  }, {
    key: "clear",
    value: function clear(destroyTextures) {
      destroyTextures = destroyTextures !== false;
      if (destroyTextures) {
        for (var i in this.texturePool) {
          var textures = this.texturePool[i];
          if (textures) {
            for (var j = 0; j < textures.length; j++) {
              textures[j].destroy(true);
            }
          }
        }
      }
      this.texturePool = {};
    }
  }, {
    key: "setScreenSize",
    value: function setScreenSize(size) {
      if (size.width === this._pixelsWidth && size.height === this._pixelsHeight) {
        return;
      }
      this.enableFullScreen = size.width > 0 && size.height > 0;
      for (var i in this.texturePool) {
        if (!(Number(i) < 0)) {
          continue;
        }
        var textures = this.texturePool[i];
        if (textures) {
          for (var j = 0; j < textures.length; j++) {
            textures[j].destroy(true);
          }
        }
        this.texturePool[i] = [];
      }
      this._pixelsWidth = size.width;
      this._pixelsHeight = size.height;
    }
  }]);
  return RenderTexturePool;
}();
RenderTexturePool.SCREEN_KEY = -1;
export { RenderTexturePool };